import axios from "./index";

// 获取发票列表

export const getInvoiceList = (offset, limit = 10) => {
  return axios
    .get("/invoice/invoices", {
      params: {
        offset,
        limit
      }
    })
    .then(res => {
      return res;
    })
    .catch(err => console.log(err));
};
